module.exports = __webpack_public_path__ + "img/prof.5bd4e52f.png";